var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#F5F7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1785 20L24.756 16.4225C25.0819 16.0966 25.0819 15.57 24.756 15.2441C24.4302 14.9183 23.9035 14.9183 23.5777 15.2441L20.0002 18.8216L16.4227 15.2441C16.0969 14.9183 15.5702 14.9183 15.2444 15.2441C14.9185 15.57 14.9185 16.0966 15.2444 16.4225L18.8219 20L15.2444 23.5775C14.9185 23.9033 14.9185 24.43 15.2444 24.7558C15.4069 24.9183 15.6202 25 15.8335 25C16.0469 25 16.2602 24.9183 16.4227 24.7558L20.0002 21.1783L23.5777 24.7558C23.7402 24.9183 23.9535 25 24.1669 25C24.3802 25 24.5935 24.9183 24.756 24.7558C25.0819 24.43 25.0819 23.9033 24.756 23.5775L21.1785 20Z",
    fill: "#082131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseIcon);
export default __webpack_public_path__ + "static/media/ModalCloseIcon.c2ae92c41253e3f5f9b3f06908012049.svg";
export { ForwardRef as ReactComponent };